import React, { useState } from "react";
import { useModalStore } from "@/hooks/useModalStore";
import { Form, Input, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { websiteValidator } from "@/biz/validator";
import { submitInfluencerLinkApi } from "@/api/order";

export default function ModalInfluencerTrackLink() {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const {
    showInfluencerTrackLinkModalInfo,
    setShowInfluencerTrackLinkModalInfo,
  } = useModalStore();
  const { visible, orderId, campaignId, isContent, updateFunc, link } =
    showInfluencerTrackLinkModalInfo;
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    if (!isContent) {
      updateFunc?.();
    }
    setShowInfluencerTrackLinkModalInfo({
      visible: false,
      orderId: "",
      campaignId: "",
      isContent: false,
    });
  };

  return (
    <Modal
      open={visible}
      title={t("common.influencerTrackLinkModal.title", {
        defaultValue: "Assign a unique promotional link to this influencer",
      })}
      okText={
        isContent
          ? t("common.buttons.approve", { defaultValue: "Approve" })
          : t("common.buttons.confirm", { defaultValue: "Confirm" })
      }
      cancelText={
        isContent
          ? t("common.buttons.cancel", { defaultValue: "Cancel" })
          : t("common.buttons.notNow", { defaultValue: "Not now" })
      }
      okButtonProps={{
        size: "large",
      }}
      cancelButtonProps={{
        size: "large",
      }}
      onOk={() => {
        form
          .validateFields()
          .then(async (values: any) => {
            try {
              setLoading(true);
              await submitInfluencerLinkApi(orderId, {
                utmLink: values.utmLink,
              });
              await updateFunc?.();
              handleCancel();
            } catch (error) {
              console.error(error);
            } finally {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }}
      onCancel={handleCancel}
      confirmLoading={loading}
    >
      <div className="flex flex-col gap-6">
        <div className="justify-start text-[#79716B] text-base font-normal font-['DM_Sans'] leading-6">
          {t("common.influencerTrackLinkModal.description", {
            defaultValue:
              "The influencer will include this link in their post or link in bio so their audience is directed to your destination.",
          })}{" "}
        </div>
        <div className="flex flex-col gap-[6px]">
          <div className="inline-flex justify-start items-start gap-0.5">
            <div className="justify-start text-Colors-Text-text-secondary-(700) text-sm font-medium font-['DM_Sans'] leading-5">
              {t("common.influencerTrackLinkModal.uniqueLinkLabel", {
                defaultValue: "Unique link",
              })}
            </div>
            <div className="justify-start text-[#EC470A] text-sm font-medium font-['DM_Sans'] leading-5">
              *
            </div>
          </div>
          <Form name="utmLinkForm" form={form}>
            <Form.Item
              name="utmLink"
              initialValue={link}
              rules={[
                {
                  required: true,
                  message: t(
                    "common.influencerTrackLinkModal.uniqueLinkRequired",
                    {
                      defaultValue:
                        "Please enter a unique promotional link for this influencer",
                    },
                  ),
                },
                {
                  validator: (_, value) => {
                    if (value && !websiteValidator(value, false, false)) {
                      return Promise.reject(
                        new Error(
                          t(
                            "campaignCreate.budgetBidding.pleaseEnterValidLink",
                            { defaultValue: "Please enter a valid link" },
                          ),
                        ),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              className="mb-0"
            >
              <Input
                placeholder={t(
                  "common.influencerTrackLinkModal.uniqueLinkPlaceholder",
                  { defaultValue: "Paste the influencer-specific URL" },
                )}
                size="large"
              />
            </Form.Item>
          </Form>
        </div>
        <div className="w-full border-t border-[#E5E5E5]"></div>
      </div>
    </Modal>
  );
}
